import React from 'react';
import PropTypes from 'prop-types';

import StarRating from '@homeaway/react-star-rating';
import { AspectRatioCard, AspectRatioCardImage } from '@homeaway/react-aspect-ratio-card';

import './PropertyCard.less';

const CNAME = 'PropertyCard';

const PropertyCard = ({
  onClick,
  aspectRatio,
  thumbnailUrl1,
  galleryUrl,
  placeholder,
  detailPageUrl,
  bedrooms,
  bathrooms,
  sleeps,
  rate,
  rateAverageNight,
  averageRating,
  ...otherProps
}) => (
  <a
    href={detailPageUrl}
    target="_blank"
    onClick={onClick}
    className={`${CNAME}__link`}
  >
    <AspectRatioCard
      aspectRatio={aspectRatio}
      {...otherProps}
    >
      <AspectRatioCardImage data-slot={'figure'} imageUri={thumbnailUrl1 || galleryUrl || placeholder} />
      <h4 data-slot={'caption'} className="AspectRatioCardTitle">
        {bedrooms && <span className={`${CNAME}__caption`}>{bedrooms}</span>}
        {bathrooms && <span className={`${CNAME}__caption`}>{bathrooms}</span>}
        {sleeps && <span className={`${CNAME}__caption`}>{sleeps}</span>}
      </h4>
      <div data-slot={'content'} className={`${CNAME}__content`}>
        {rate && <span className="small overflow-ellipsis">{`${rate} ${rateAverageNight}`}</span>}
        <StarRating rating={averageRating} />
      </div>
    </AspectRatioCard>
  </a>
);

PropertyCard.propTypes = {
  bedrooms: PropTypes.string,
  bathrooms: PropTypes.string,
  detailPageUrl: PropTypes.string,
  sleeps: PropTypes.string,
  rate: PropTypes.string,
  rateAverageNight: PropTypes.string,
  placeholder: PropTypes.string.isRequired,
  thumbnailUrl1: PropTypes.string,
  galleryUrl: PropTypes.string,
  aspectRatio: PropTypes.string.isRequired,
  onClick: PropTypes.func
};

PropertyCard.defaultProps = {
  aspectRatio: '4x3',
  placeholder: 'http://csvcus.homeaway.com/rsrcs/cdn-logos/2.6.1/bce/brand/misc/property-image-placeholder.svg'
};

export default PropertyCard;



// WEBPACK FOOTER //
// ./src/universal/components/Scratchpad/PropertyCard.js